﻿export default class TagFilter {
    
    constructor(element) {
        this._element = element;

        this.init();

    }
    
    init() {
        const base = this;

        base._element.querySelectorAll('a').forEach(anchor => {

            anchor.addEventListener('click', evt => {
                var hash = evt.target.getAttribute('href');
                if (evt.target.classList.contains('active')) {
                    evt.preventDefault();
                    window.history.pushState('', document.title, window.location.pathname);
                    hash = null;
                }

                base.filterList(hash);
            });
        });

        // Initial filter (from url)
        base.filterList(null);
    }

    filterList(hash) {
        const base = this;

        if (!hash) {
            hash = decodeURIComponent(window.location.hash);
        }

        // Manage filter buttons
        base._element.querySelectorAll('a').forEach(anchor => {
            anchor.classList.remove('active');

            if (anchor.getAttribute('href') === hash)
                anchor.classList.add('active');
        });

        const listWrapper = base._element.nextElementSibling;

        if (!hash) {
            listWrapper.querySelectorAll('*[data-tags]').forEach(element => { element.classList.remove('d-none'); });
            return;
        }

        // Filter
        listWrapper.querySelectorAll('*[data-tags]').forEach(element => {
            element.classList.add('d-none');
        });

        listWrapper.querySelectorAll('*[data-tags*="' + hash.replace('#', '') + '"]').forEach(element => {
            element.classList.remove('d-none');
        });
    }
};